(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/javascripts/constants.js');

'use strict';

const containerStates = {
  CONTAINER_CLOSED: 'CONTAINER_CLOSED',
  CONTAINER_OPEN: 'CONTAINER_OPEN',
  GAME_SOLD_OUT: 'GAME_SOLD_OUT'
};
const apiPaths = {
  socket: () => '/marketplace/1/svs/activateddraws/updates'
};
svs.numbergames.fractiongames.constants = {
  containerStates,
  apiPaths
};

 })(window);